import { render, staticRenderFns } from "./SlatForm.vue?vue&type=template&id=5dd5106e"
import script from "./SlatForm.vue?vue&type=script&lang=js"
export * from "./SlatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports